import { DATA_BASE_URL, STAR_MAPPING_URL } from './constants.js';
import { slugify } from './helpers.js';

const DATA_URL = STAR_MAPPING_URL;
let loadPromise = null;

function isFiniteNumber(value) {
	return typeof value === 'number' && Number.isFinite(value);
}

function deriveBoundarySlug(boundaryPath) {
	if (typeof boundaryPath !== 'string' || !boundaryPath) {
		return null;
	}
	const trimmed = boundaryPath.trim();
	if (!trimmed) {
		return null;
	}
	let slug = trimmed.replace(/\.geojson$/i, '');
	const boundaryBase = `${DATA_BASE_URL}/nations/boundaries`;
	const prefixes = ['data/nations/boundaries', 'nations/boundaries', boundaryBase];
	for (let i = 0; i < prefixes.length; i += 1) {
		const rawPrefix = prefixes[i];
		if (!rawPrefix) {
			continue;
		}
		const normalizedPrefix = rawPrefix.replace(/\/+$/, '');
		const normalizedSlug = slug.toLowerCase();
		const normalizedPrefixLower = normalizedPrefix.toLowerCase();
		if (normalizedSlug === normalizedPrefixLower) {
			slug = '';
			break;
		}
		if (normalizedSlug.indexOf(`${normalizedPrefixLower}/`) === 0) {
			slug = slug.slice(normalizedPrefix.length + 1);
			break;
		}
	}
	return slug || null;
}

function buildCountryEntry(slug, entry) {
	const coordinates = entry.coordinates || {};
	if (!isFiniteNumber(coordinates.lat) || !isFiniteNumber(coordinates.lon)) {
		return null;
	}
	return {
		slug,
		name: entry.name || slug,
		lat: coordinates.lat,
		lon: coordinates.lon,
		boundary: deriveBoundarySlug(entry.boundary)
	};
}

function buildCityEntries(slug, entry) {
	const items = Array.isArray(entry.cities) ? entry.cities : [];
	const results = [];
	for (let i = 0; i < items.length; i += 1) {
		const city = items[i];
		if (city && city.synthetic) {
			continue;
		}
		const coordinates = city && city.coordinates;
		if (!coordinates) {
			continue;
		}
		const { lat, lon } = coordinates;
		if (!isFiniteNumber(lat) || !isFiniteNumber(lon)) {
			continue;
		}
		const slugValue =
			(city && typeof city.slug === 'string' && city.slug) ||
			slugify(city && city.name ? city.name : `${slug}-city-${i}`);
		results.push({
			nation: slug,
			name: city.name || city.slug || `city-${i}`,
			slug: slugValue,
			lat,
			lon
		});
	}
	return results;
}

function transformData(data) {
	const countries = [];
	const cities = [];
	const entries = Object.entries(data || {});
	for (let i = 0; i < entries.length; i += 1) {
		const [slug, entry] = entries[i];
		const countryEntry = buildCountryEntry(slug, entry || {});
		if (countryEntry) {
			countries.push(countryEntry);
		}
		const nationCities = buildCityEntries(slug, entry || {});
		Array.prototype.push.apply(cities, nationCities);
	}
	return { countries, cities };
}

export function loadLocationData() {
	if (loadPromise) {
		return loadPromise;
	}
	loadPromise = fetch(DATA_URL, { cache: 'no-cache' })
		.then((response) => {
			if (!response.ok) {
				throw new Error(`Failed to load ${DATA_URL}: ${response.status}`);
			}
			return response.json();
		})
		.then((json) => {
			const { countries, cities } = transformData(json);
			globalThis.countries = countries;
			globalThis.cities = cities;
		})
		.catch((error) => {
			console.error('Unable to load star mapping data', error);
			globalThis.countries = [];
			globalThis.cities = [];
			throw error;
		});
	return loadPromise;
}
